import type { ComponentProps } from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";

import { cn } from "@/lib/utils";

/** Keep the selection mark small while the actual pointer target follows density. */
export function RecordSelectionCheckbox({
  className,
  ...props
}: ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="record-selection-checkbox"
      className={cn(
        "relative inline-flex size-[var(--control-height-compact)] shrink-0 items-center justify-center rounded-control outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 before:absolute before:size-4 before:rounded-xs before:border before:border-input before:bg-card data-[state=checked]:before:border-primary data-[state=checked]:before:bg-primary data-[state=indeterminate]:before:border-primary data-[state=indeterminate]:before:bg-primary",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="relative flex items-center justify-center text-primary-foreground">
        <Check aria-hidden="true" className="size-3.5 in-data-[state=indeterminate]:hidden" strokeWidth={1.75} />
        <Minus aria-hidden="true" className="hidden size-3.5 in-data-[state=indeterminate]:block" strokeWidth={1.75} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
